import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TableState } from '../_reducers/table.reducers';

const getNavigationState = createFeatureSelector<TableState>('table');

export const getTablesLoading = createSelector(
  getNavigationState,
  (state: TableState) => state.tablesLoading
);

export const getAllTablesLoading = createSelector(
  getNavigationState,
  (state: TableState) => state.allTablesLoading
);

/**
 * Select navigation
 */
export const getNavigation = createSelector(
  getNavigationState,
  (state: TableState) => state.navigation
);

/**
 * Select operations
 */
export const getTableOperations = createSelector(
  getNavigationState,
  (state: TableState) => state.operations
);

/**
 * Select validate name
 */
export const getValidateName = createSelector(
  getNavigationState,
  (state: TableState) => state.validateName
);

/**
 * Select tables
 */
export const getTables = createSelector(
  getNavigationState,
  (state: TableState) => state.tables
);
/**
 * Select tables
 */
export const getAllTables = createSelector(
  getNavigationState,
  (state: TableState) => state.allTables
);


/**
 * Select tables
 */
export const getPagesAndDashboard = createSelector(
  getNavigationState,
  (state: TableState) => state.tables
);

/**
 * Selector for API to check if table has data
 */
export const checkTableHasData = createSelector(
  getNavigationState,
  (state: TableState) => state.checkTableData
)

/**
 * Select error
 */
export const getTableError = createSelector(
  getNavigationState,
  (state: TableState) => state.error
);
